"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var utils_1 = require("../utils");
// tslint:disable-next-line:max-line-length variable-name
function withFormValues(formName) {
    // tslint:disable-next-line:variable-name
    return function (Component) {
        // tslint:disable-next-line:max-classes-per-file
        var WithFormValues = /** @class */ (function (_super) {
            __extends(WithFormValues, _super);
            function WithFormValues(props) {
                var _this = _super.call(this, props) || this;
                _this.form = props.formStore.getForm(formName);
                if (!_this.form) {
                    // tslint:disable-next-line:max-line-length
                    throw (new Error("Form '" + formName + "' does not exist in store. Please check call to 'withFormValues(" + formName + ")(" + Component.name + ")'"));
                }
                return _this;
            }
            WithFormValues.prototype.render = function () {
                return (React.createElement(Component, __assign({ values: this.form.values }, utils_1.omit(this.props, ['formStore']))));
            };
            WithFormValues = __decorate([
                mobx_react_1.inject('formStore'),
                mobx_react_1.observer,
                __metadata("design:paramtypes", [Object])
            ], WithFormValues);
            return WithFormValues;
        }(React.Component));
        return WithFormValues;
    };
}
exports.withFormValues = withFormValues;
//# sourceMappingURL=withFormValues.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/hoc/withFormValues.js
// module id = 134
// module chunks = 0